const API_URL = process.env.REACT_APP_API_URL || '/api';

/** In-memory only — cleared on hard refresh / tab close (not persisted). */
let authToken = '';

try {
  // Drop any legacy persisted session from older builds
  localStorage.removeItem('dynafi_token');
  sessionStorage.removeItem('dynafi_token');
} catch {
  // ignore
}

function getToken() {
  return authToken || '';
}

export function setToken(token) {
  authToken = token || '';
}

let unauthorizedHandler = null;

/** Called when a stored session is rejected (signed in elsewhere). */
export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler;
}

async function request(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  const data = await res.json().catch(() => ({}));
  if (
    res.status === 401 &&
    token &&
    path !== '/auth/wallet-login' &&
    path !== '/auth/register' &&
    path !== '/auth/register/check'
  ) {
    setToken('');
    if (typeof unauthorizedHandler === 'function') unauthorizedHandler();
  }
  if (!res.ok) {
    const err = new Error(data.message || 'Request failed');
    err.status = res.status;
    err.code = data.code;
    err.data = data;
    throw err;
  }
  return data;
}

export const api = {
  getConfig: () => request('/config'),
  pancakeQuote: () => request('/swap/quote'),
  commissions: () => request('/commissions'),
  myCommissions: () => request('/commissions/me'),
  walletLogin: (walletAddress) =>
    request('/auth/wallet-login', { method: 'POST', body: { walletAddress } }),
  checkRegister: (walletAddress, uplineWallet) =>
    request('/auth/register/check', {
      method: 'POST',
      body: { walletAddress, uplineWallet },
    }),
  register: (walletAddress, uplineWallet, txHash) =>
    request('/auth/register', {
      method: 'POST',
      body: { walletAddress, uplineWallet, txHash },
    }),
  me: () => request('/auth/me'),
  startPurchase: (amountUsdt) =>
    request('/purchases', { method: 'POST', body: { amountUsdt } }),
  openPurchase: () => request('/purchases/open'),
  purchaseStatus: (id) => request(`/purchases/${id}`),
  submitPurchaseTx: (id, txHash) =>
    request(`/purchases/${id}/tx`, { method: 'POST', body: { txHash } }),
  myPurchases: () => request('/purchases/me'),
  stakingSlabs: () => request('/staking/slabs'),
  startStake: (slabId, amountDfi) =>
    request('/stakes', { method: 'POST', body: { slabId, amountDfi } }),
  stakeStatus: (id) => request(`/stakes/${id}`),
  submitStakeTx: (id, txHash) => request(`/stakes/${id}/tx`, { method: 'POST', body: { txHash } }),
  claimStake: (id) => request(`/stakes/${id}/claim`, { method: 'POST', body: {} }),
  myStakes: () => request('/stakes/me'),
  claim: (amount) => request('/claims', { method: 'POST', body: { amount } }),
  myClaims: () => request('/claims/me'),
  myIncome: () => request('/income/me'),
  myTeam: () => request('/team/me'),
  myRank: () => request('/rank/me'),
  referralLeaders: () => request('/referral-leaders'),
  todayDepositLeaders: () => request('/purchases/today-leaders'),
};
